import React from 'react';
import Header from '../components/Header.jsx';
import './Layout.css';
import { Container, Grid } from "@mui/material";


const Layout = ({ children }) => {
    return (

        <div className={"layout"} style={{ padding: '0px 0px 20px 0px' }}>
            <Header />
            <Container maxWidth="xl" style={{ paddingBottom: '20px' }}>
                <div className='mt-2 px-sm-2 px-0'>
                    {children}
                </div>
            </Container>
        </div>

    );
};

export default Layout;